const PriceAndImage = require('../../components/price-and-image');

module.exports = PriceAndImage;
